<div *ngIf="filters.length > 0">
	<form nz-form [formGroup]="filterForm">
		<div formArrayName="conditions">
			<div *ngFor="let group of conditions.controls; let i = index" [formGroupName]="i"
				class="mb-3 border rounded p-3">
				<div class="row">
					<div class="col-5">
						<nz-form-item>
							<nz-form-label [nzSpan]="6">Property</nz-form-label>
							<nz-form-control [nzSpan]="18">
								<nz-select formControlName="propertyId">
									<nz-option *ngFor="let filter of filters" 
										[nzValue]="filter.id" 
										[nzLabel]="filter.name"
										[nzDisabled]="isPropertySelected(filter, i)"></nz-option>
								</nz-select>
							</nz-form-control>
						</nz-form-item>
					</div>
					<div class="col-5">
						<ng-container *ngIf="group.get('propertyId')?.value as selectedProperty">
							<ng-container *ngIf="getPropertyConfig(selectedProperty) as config">

								<!-- Text input -->
								<nz-form-item *ngIf="config.dataType === 'Text'">
									<nz-form-label [nzSpan]="6">Value</nz-form-label>
									<nz-form-control [nzSpan]="18">
										<input nz-input formControlName="value" />
									</nz-form-control>
								</nz-form-item>

								<!-- Dropdown input -->
								<nz-form-item *ngIf="config.dataType === 'DropDownSingle' || config.dataType === 'SelectFromRecords'">
									<nz-form-label [nzSpan]="6">Value</nz-form-label>
									<nz-form-control [nzSpan]="18">
										<nz-select formControlName="value" nzPlaceHolder="Select">
											<nz-option *ngFor="let opt of config.options" 
												[nzLabel]="opt.label"
												[nzValue]="opt"></nz-option>
										</nz-select>
									</nz-form-control>
								</nz-form-item>

								<!-- Boolean input -->
								<nz-form-item *ngIf="config.dataType === 'Boolean'">
									<nz-form-control [nzSpan]="24">
										<label nz-checkbox formControlName="value">True / False</label>
									</nz-form-control>
								</nz-form-item>

								<!-- PastDate input -->
								<nz-form-item *ngIf="config.dataType === 'PastDate'">
									<nz-form-label [nzSpan]="6">Condition</nz-form-label>
									<nz-form-control [nzSpan]="8">
										<nz-select formControlName="operator" nzPlaceHolder="Select operator">
											<nz-option *ngFor="let op of operatorOptions" [nzLabel]="op.label"
												[nzValue]="op.value"></nz-option>
										</nz-select>
									</nz-form-control>
									<nz-form-control [nzSpan]="10">
										<nz-date-picker formControlName="value" nzPlaceHolder="Select date"></nz-date-picker>
									</nz-form-control>
								</nz-form-item>
							</ng-container>
						</ng-container>
					</div>
					<div class="col text-end">
						<button nz-button nzType="default" nzDanger (click)="removeCondition(i)">
							<i nz-icon nzType="delete"></i>
							Remove
						</button>
					</div>
				</div>
			</div>
		</div>
	</form>

	<button nz-button nzType="dashed" (click)="addCondition()">
		<i nz-icon nzType="plus"></i> Add Filter
	</button>

	<div class="text-end mt-4">
		<button nz-button nzType="primary" (click)="onSubmit()">Apply Filters</button>
	</div>
</div>